import { account } from '../../../store.config'

const maintenanceLinks = [
  '/cartao',
  '/resgate-de-pontos',
  '/econometro',
  '/aceitar-termos-promocao',
  '/institucional/lojas',
  '/institucional/sobre',
  '/institucional/trabalheConosco',
  '/institucional/termos',
  '/institucional/privacidade',
  '/institucional/politica-cookie',
]

const verifyMaintenance = (link: { pathname?: string; search?: string }) => {
  if (
    account !== 'avenidab2c' &&
    account !== 'superpao' &&
    account !== 'compremais'
  ) {
    return true
  }

  const pathname = link?.pathname || ''
  const search = link?.search || ''

  if (
    pathname.includes('/campanhas') &&
    (search.includes('nameLp=Lojas') || search.includes('namelp=Lojas'))
  ) {
    return true
  }

  return maintenanceLinks.some((linkPath) => pathname.includes(linkPath))
}

export { verifyMaintenance }
